import React, { useState, useEffect } from 'react';
import { Signal, Wifi, Battery, Clock } from 'lucide-react';

const StatusBar: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format time in retro style: HH:MM:SS
  const formattedTime = time.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  return (
    <div className="bg-card/30 border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-end h-6 text-xs text-muted-foreground font-mono">
          <div className="flex items-center space-x-3">
            <div className="flex items-center">
              <Signal size={12} className="text-primary" />
              <span className="ml-1">100%</span>
            </div>
            <div className="flex items-center">
              <Wifi size={12} className="text-secondary" />
              <span className="ml-1">CONNECTED</span>
            </div>
            <div className="flex items-center">
              <Battery size={12} className="text-accent" />
              <span className="ml-1">OPTIMAL</span>
            </div>
            <div className="flex items-center">
              <Clock size={12} className="text-chart-1" />
              <span className="ml-1">{formattedTime}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;